import { Link } from "react-router-dom";
import ReactPlayer from "react-player/file";
import { HeaderSidebar } from "../../../components/Header/HeaderSidebar";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setProgress } from "../../../store/progressSlice";
import { ProgressLine } from "../../../components/Progress/Line";

export const PurposeIntroduction = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setProgress(10))
    }, [])

    return (
        <>
            <ProgressLine />
            <main className={"purpose has-black-bg container min-h-dvh"}>
                <section className="flex flex-col">
                    <div className="video-container">
                        <ReactPlayer
                            url="https://www.dropbox.com/scl/fi/d4mwyl3fqdraqyds9he85/4-Purpose.mp4?rlkey=t7yqgsp2cf5pd8xba77v73c02&raw=1"
                            playing
                            controls
                            className='react-player'
                            width="100%"
                            height="100%" />
                    </div>
                    <div className="flex items-center gap-5 mt-8">
                        <Link to={"/flow/intro"}>
                            <span className="outlined-cta">
                                Back
                            </span>
                        </Link>
                        <Link to={"/flow/purpose/passion"}>
                            <span className="yellow-cta">
                                Next
                            </span>
                        </Link>
                    </div>
                </section>
                <HeaderSidebar activeEl="Purpose" />
            </main>
        </>
    )
}